<template>
	<div>
		<!-- <Datepicker
			v-model="selectedDate"
			:format="format"
			:placeholder="placeholder"
			:disabled="disabled"
			:clearable="clearable"
			@input="emitDate"
		></Datepicker> -->
		<VueDatePicker 
			v-model="date" 
			auto-apply 
			:format="format"
		></VueDatePicker>
	</div>
</template>

<script>
// import Datepicker from "vue-datepicker";
// import moment from 'moment';
import { ref, onMounted } from 'vue';
export default {
	// components: {
	// 	Datepicker,
	// },
	props: {
		date: {
			type: String,
			default: () => moment().format('YYYY-MM-DD'), // Default to today's date if not provided
		},
		format: {
			type: String,
			default: "YYYY-MM-DD",
		},
		placeholder: {
			type: String,
			default: "Select Date",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		clearable: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			selectedDate: this.date || moment().format(this.format),
			date: ref(new Date())
		};
	},
	watch: {
		value(newValue) {
			this.selectedDate = newValue || moment().format(this.format);
		},
	},
	methods: {
		emitDate() {
			this.$emit("input", this.selectedDate);
		},
	},
};
</script>

<style scoped>
/* Add any custom styles here */
</style>
